export default __webpack_public_path__ + "static/media/products_412.a2ff8694.jpg";